import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 Mohd Aman. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
